import axios from 'axios';
import OnboardingIndex from '../OnboardingIndex.vue';
import { LOGIN_URL } from '@/utils/system_constants/constant.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { get_api_error_message, get_api_response_message, parse_api_data } from '@/utils/api_error_message';
import { set_login_session } from '@/utils/auth/session_manager';

export default {
  name: 'UserLogin',
  components: {
    OnboardingIndex
  },
  mixins: [alert_mixin],
  data() {
    return {
      title: 'Welcome Back',
      submitButtonText: 'Sign In',
      url_forgot_password: '/forgot_password',
      verification_running: false,
      username: '',
      password: '',
      show_password: false
    };
  },
  methods: {
    async login_function() {
      if (!this.username || !this.password) {
        this.show_error('Please enter your username and password.');
        return;
      }

      this.verification_running = true;

      try {
        const response = await axios.post(LOGIN_URL, {
          username: this.username,
          password: this.password
        });

        const response_data = parse_api_data(response.data);

        if (response_data?.status && response_data.status !== 'success') {
          this.show_error(get_api_response_message(response_data, 'Login failed.'));
          return;
        }

        if (!response_data?.token) {
          this.show_error(get_api_response_message(response_data, 'Login failed.'));
          return;
        }

        const land_court_entity_type_id = Number(
          response_data.entity_type_id
          || response_data.entityTypeId
          || response_data.entity_type?.id
          || response_data.user?.entity_type_id
          || 0
        );
        set_login_session({
          token: response_data.token,
          is_aic_one_login: false,
          land_court_entity_type_id: (
            Number.isFinite(land_court_entity_type_id) && land_court_entity_type_id > 0
              ? land_court_entity_type_id
              : null
          ),
        });

        this.$store.dispatch('setCurrentUserId', response_data.user_id);
        this.$store.dispatch('setCurrentLeadId', response_data.lead_id);
        this.$store.dispatch('setCurrentRole', response_data.role_type);
        this.$store.dispatch('setCurrentLeadName', response_data.full_name);

        this.$router.push('/one_time_pin');
      } catch (error) {
        this.show_error(get_api_error_message(error, 'Login failed.'));
      } finally {
        this.verification_running = false;
      }
    },

    toggle_password_visibility() {
      this.show_password = !this.show_password;
    }
  }
};
